import { ACME_INSURANCE_RENEWAL_DEMO_USER_PROMPT } from './acmeInsuranceRenewalDemoContent.js'

/** @param {string} trimmed */
function normalizePrompt(trimmed) {
  return String(trimmed ?? '').trim().replace(/\s+/g, ' ').toLowerCase()
}

/** @param {string} trimmed */
export function isAcmeInsuranceRenewalDemoPrompt(trimmed) {
  const normalized = normalizePrompt(trimmed)
  if (normalized === normalizePrompt(ACME_INSURANCE_RENEWAL_DEMO_USER_PROMPT)) {
    return true
  }
  return (
    normalized.includes('acme insurance') &&
    normalized.includes('customer brief') &&
    normalized.includes('renewal')
  )
}
